import React, { useState, useEffect } from "react"
import auth0 from "auth0-js"
import { useFormik } from "formik"
import * as Yup from "yup"

import { LabelledInput } from "../inputs"
import { useAuth } from "../../providers/auth/AuthProvider"
import { auth } from "../../utils/auth"
import { Button } from "../button"
import { SuccessNotice } from "../notice"
import Fieldset from "../fieldset"
import { useAuth0 } from "@auth0/auth0-react"
import updateUserMetaRecord from "../../bssr-api/auth0/update-user-meta"

export default function HospitalDetailsForm() {
  const { isAuthenticated, getIdTokenClaims } = useAuth0()
  const [state, dispatch] = useAuth()
  const [isSuccess, setIsSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [initialFormValues, setInitialValues] = useState({
    department: "",
    trust: "",
    site: "",
  })

  useEffect(() => {
    if (state.user_metadata) {
      setInitialValues({
        ...state.user_metadata.hospital,
      })
    }
  }, [state.user_metadata])

  const hospitalDetailsSchema = Yup.object().shape({
    department: Yup.string().required("This is a required field"),
    trust: Yup.string().required("This is a required field"),
    site: Yup.string().required("This is a required field"),
  })

  const formik = useFormik({
    validateOnBlur: false,
    validateOnChange: false,
    enableReinitialize: true,
    initialValues: {
      ...initialFormValues,
    },

    onSubmit: (values) => {
      setIsLoading(true)

      getIdTokenClaims()
        .then((res) => {
          const idToken = res.__raw
          const data = { hospital: { ...values } }

          updateUserMetaRecord(state.user_id, data, false, idToken)
            .then((res) => {
              if (res.data) {
                dispatch({ type: "setUser", payload: res.data })
                setIsSuccess(true)
              } else {
                alert(
                  "There was a problem updating your profile. Please try again."
                )
                console.error("updateUserMetaRecord() issue with res", res)
              }
              setIsLoading(false)
            })
            .catch((err) => {
              alert(
                "There was a problem updating your profile. Please try again."
              )
              console.error("updateUserMetaRecord() error", err)
            })
        })
        .catch((err) => console.error("err", err))
    },

    validationSchema: hospitalDetailsSchema,
  })

  const errors = formik.errors

  return (
    <form className="mt-3 mb-6" onSubmit={formik.handleSubmit}>
      <h3 className="font-bold text-lg lg:text-xl text-gray-800 py-3 mt-4">
        Hospital Details
      </h3>
      {isSuccess && (
        <SuccessNotice>
          Your hospital details were updated successfully.
        </SuccessNotice>
      )}
      <Fieldset name="hospital-details">
        <div className="flex flex-wrap">
          <div className="w-full md:w-1/2 md:pr-2">
            <LabelledInput
              label="Department*"
              id="department"
              name="department"
              value={formik.values.department}
              error={errors.department}
              onChange={formik.handleChange}
            />
          </div>
          <div className="w-full md:w-1/2 md:pl-2">
            <LabelledInput
              label="Trust*"
              id="trust"
              name="trust"
              value={formik.values.trust}
              error={errors.trust}
              onChange={formik.handleChange}
            />
          </div>
          <div className="w-full md:w-1/2 md:pr-2">
            <LabelledInput
              label="Site*"
              id="site"
              name="site"
              value={formik.values.site}
              error={errors.site}
              onChange={formik.handleChange}
            />
          </div>
        </div>
      </Fieldset>

      <Button
        isLoading={isLoading}
        type="submit"
        className="w-full md:w-1/4 mt-4"
      >
        Update Hospital Details
      </Button>
    </form>
  )
}
